jQuery(document).ready(function() {

    // check if dropdown-windows are positioned out of screen - if so,fix position
    window.fixDropdownPos = function() {
        $('.dropdown-window .dropdown-window__content.dropdown-window__content--visible').each( function() {
            var $window = $(this);
            var min_xPos = 15;
            var max_xPos = ( $(window).width()-15 )-$window.outerWidth();
            var defaultMarginLeft = -145;

            if( $window.hasClass('dropdown-window__content--moved') ) {
                $window.removeClass('dropdown-window__content--moved').css({ 'marginLeft' : defaultMarginLeft });
            }

            var xPos = $window.offset().left;
            var currentMarginLeft = parseInt( $window.css('marginLeft') );

            if( xPos < min_xPos ) {
                var xDifference = min_xPos - xPos;

                if( xDifference > 0 ) {
                    $window.addClass('dropdown-window__content--moved').css({ 'marginLeft' : (currentMarginLeft+xDifference) });
                }
            } else if( xPos > max_xPos ) {
                var xDifference = xPos - max_xPos;

                if( xDifference > 0 ) {
                    $window.addClass('dropdown-window__content--moved').css({ 'marginLeft' : (currentMarginLeft-xDifference) });
                }
            }
        });
    }


    // dropdown-windows
    $('[data-toggle="dropdown-window"]').click( function() {
        var $wrapper = $(this).closest('.dropdown-window');
        var $content = $wrapper.find('.dropdown-window__content');

        // close all other currently open dropdowns
        $('.dropdown-window').not( $wrapper ).each( function() {
            if( $('.dropdown-window__content', this).hasClass('dropdown-window__content--visible') ) {
                $('.dropdown-window__content', this).removeClass('dropdown-window__content--visible');
            }
        });

        if( $content.hasClass('dropdown-window__content--visible') ) {
            $content.removeClass('dropdown-window__content--visible');
        } else {
            $content.addClass('dropdown-window__content--visible');
            fixDropdownPos();
        }

        $(this).blur();
    });


    // auto reopen dropdown if contains form with errors of confirm message
    $('.dropdown-window .dropdown-window__content .gform_wrapper.gform_validation_error, .dropdown-window .dropdown-window__content .gform_confirmation_wrapper').each( function() {
        var $wrapper = $(this).closest('.dropdown-window__content');

        $wrapper.addClass('.dropdown-window__content--visible');
        fixDropdownPos();
    });


    // document click events - for closing components when clicking outside of them
    $(document).on('click', function(e) {

        // close html dropdowns
        if( !$(e.target).closest('.dropdown-window').length ) {
            $('.dropdown-window').each( function() {
                if( $('.dropdown-window__content', this).hasClass('dropdown-window__content--visible') ) {
                    $('.dropdown-window__content', this).removeClass('dropdown-window__content--visible');
                }
            });
        }

    });


    // if dropdown window contains link-list, close it on change
    $('.dropdown-window .link-list input').change( function() {
        var $window_content = $(this).closest('.dropdown-window__content');
        var newVal = $(this).next('.link').find('.link__text').html(); // don't add input value but 'pretty' link text

        if( $window_content.hasClass('dropdown-window__content--visible') ) {
            $window_content.removeClass('dropdown-window__content--visible');
        }

        // also set new value to fake-input element
        if( $(this).closest('.form-field').find('.form-field__fake-input').length ) {
            $(this).closest('.form-field').find('.form-field__fake-input .field-text').html(newVal);
        }
    });

});